import { CompanyPension } from "src/types";
import { moyrToAnnual, splitDate } from "../utils";
import { adjustForIncrease, adjustForInflation, isDead } from "./utils";
import { CalculationInfo } from "./types";
import { startEndToYear } from "src/components/Info/StartEndSelect";

export const calculate = (info: CalculationInfo<CompanyPension>) => {
  const startYear = new Date().getFullYear();
  const { people, income, currentYear } = info;
  const person = people[income.personId];
  const { year: birthYear } = splitDate(person.birthday);
  const age = currentYear - birthYear;

  const startYearr = startEndToYear(income.start, info.people, info.scenario);
  const startAge = startYearr ? startYearr - birthYear : 0;
  const start = startAge ? startAge + birthYear : startYear;

  // let yearAmount =
  //   income.annualAmount *
  //   Math.pow(
  //     1 + (income.yearlyIncreasePercent || 0) / 100,
  //     currentYear - start,
  //   );
  const annualIncome = income.amount
    ? moyrToAnnual(income.amount)
    : income.annualAmount;

  let yearAmount = adjustForIncrease(info, annualIncome, start);

  yearAmount = adjustForInflation(info, yearAmount, start);

  if (startAge && startAge > age) {
    return 0;
  }

  if (isDead(info, income.personId)) {
    return (yearAmount * income.survivorPercent) / 100;
  }
  if (startAge === age) {
    return (yearAmount * income.firstYearProRatePercent) / 100;
  }

  return yearAmount;
};

export const calculateCompanyPension = (
  info: CalculationInfo<CompanyPension>,
) => {
  return { amount: calculate(info), note: "" };
};
